import { AbstractControl } from "@angular/forms";

export function PasswordNoLowercaseValidator(control: AbstractControl): any {
  const newPassword = control.value;

  let atLeast1LowerCharacter = false;
  for (let i = 0; i < newPassword.length; i++) {
    if (
      newPassword[i] === newPassword[i].toLowerCase() &&
      newPassword[i] !== newPassword[i].toUpperCase()
    ) {
      atLeast1LowerCharacter = true;
    }
  }

  if (!atLeast1LowerCharacter) {
    return { passwordNoLowercase: true };
  }

  return null;
}
